// assets/bb-home-categorias.js
// Antes isto era um <script> inline em rgd-category-hover-carousel.liquid que achava a
// própria seção por `document.querySelector('#rgd-category-hover-{{ section.id }}')`
// (Liquid interpolado no JS). Agora é um módulo por arquivo: a seção ganhou o atributo
// `data-categoria-hover-carousel` e o script varre todas as ocorrências pelo DOM, do
// mesmo jeito que bb-home-carrossel-animado.js. Cada instância emite o próprio <script defer>,
// então a trava data-bb-categorias-pronto liga cada seção uma vez só.
(() => {
  document.querySelectorAll('[data-categoria-hover-carousel]').forEach((section) => {
    if (section.hasAttribute('data-bb-categorias-pronto')) return;
    section.setAttribute('data-bb-categorias-pronto', '');
    const track = section.querySelector('[data-track]');
    const prev = section.querySelector('[data-prev]');
    const next = section.querySelector('[data-next]');

    if (!track || !prev || !next) return;

    const getStep = () => {
      const card = track.querySelector('.rgd-category-hover__card');
      if (!card) return 0;

      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      return card.offsetWidth + gap;
    };

    prev.addEventListener('click', () => {
      track.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });

    next.addEventListener('click', () => {
      track.scrollBy({ left: getStep(), behavior: 'smooth' });
    });
  });
})();
